import useSession from "hooks/useSession";
import {
	LegalFooter,
	PTmbDateBus,
	PTmbDetailActivity,
	PTmbLanguageBus,
	PTmbPassengers,
	UiAveStepper,
} from "libs/raas-ui-react-components/src/components";
import { getFooterLiterals } from "pages/private/AveFlow/AveFlow.util";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	formatDate,
	getLiteralsDateLanguage,
	getLiteralsPageLanguage,
	getResumenLiterals,
	getTmbLenguageModal,
	literalDetailTmb,
	mappedSessions,
	nightBusStep
} from "./TmbNightBusFlow.util";
import { useNavigate, useLocation } from "react-router-dom";
import {
	getTmbActivitySelected,
	setTMBSummaryDetail,
	initTMBSummaryDetail,
	setTmbActivitySelected,
	removeTMBSummaryDetail,
	getIdTmbSelect,
	setOffSite,
	setDataCodePromoSession,
} from "services/user/user.session.service";
import { getLiteralsPagePassenger, getTmbPassengerSeniorModal } from "../TmbNormalFlow/TmbNormalFlow.util";
import { LoginModal } from "../LoginModal/LoginModal";
import { IDetailTmb } from "../TmbDetailActivity/TmbDetailActivity.model";
import {  getDetailTmbNigth, getLanguageTMB } from "../TmbDetailActivity/TmbDetailActivity.service";

export const TmbNightBusFlow = () => {
	const { userConnected, cardTMB, logged, productTMBDetails, setProductTMBDetails } =
		useSession();
	const navigate = useNavigate();
	const location = useLocation();
	const [t, i18n] = useTranslation("tmbPages");
	const [t2] = useTranslation("aveFlow");
	const [t3] = useTranslation("tmbModals");

	const footerLiterals = getFooterLiterals(t2);
	const literalsPageLanguage = getLiteralsPageLanguage(t);
	const literalsModal = getTmbLenguageModal(t3)
	const pageLiterals = getResumenLiterals(t);
	const literalsPassengers = getLiteralsPagePassenger(t);


	const [literalsDateLanguage, setLiteralsDateLanguage] = useState(getLiteralsDateLanguage(t));
	

	const [idDetail, setIdDetail] = useState(getIdTmbSelect());
	const [detailDataTmb, setDetailDataTmb] = useState<IDetailTmb[]>();
	
	const [languageData, setLanguageData] = useState(null);
	
	const [activitySelectedIndex, setActivitySelectedIndex] = useState(0);
	const [callSucess, setCallSucess] = useState(false);


	const [currentStep, setCurrentStep] = useState(0);

	const [showLoginModal, setShowLoginModal] = useState(false);
	const [openMissing, setOpenMissing] = useState(false);


	const literalsDetail: any = literalDetailTmb(t)
	
	const [dataForm, setDataForm] = useState({
		id: getIdTmbSelect(),
		title: "",
		secondaryTitle: "",
		contextType: "",
		provider: "",
		language: initTMBSummaryDetail()?.language ?? { value: "", time: "" ,id:"",noMapped:""},
		date: initTMBSummaryDetail()?.date ?? {
			value: "",
			valueFormat: "",
			time: "",
			zulu:"",
			serviceDate:""
		},
		passengers: initTMBSummaryDetail()?.passengers ?? {
			passengers: [],
			totalCount: 0,
			totalPrice: 0,
		},
		languageData:"",
	});

	useEffect(() => {
		const fromResume = location.state?.fromResume;
		if (fromResume) {
			setCurrentStep(0);
		}
	}, [location.state]);

	const passengersInfo = () => {
		const selectedPassengers = initTMBSummaryDetail()?.passengers;
		return getTmbActivitySelected().price.map(
			(item: any, index: number) => {
				return {
					id: item.type,
					passenger: item.type,
					passPrice: item.gross,
					isAdult: item.isAdult,
					counter: 0,
					contextValue: item.contextValue,
					min: item.type === "Adultos" ? 1:0,
					max: 9,
					default: selectedPassengers?.passengers[index]?.counter,
				};
			},
		);
	};



	let lenguage = "";

	useEffect(() => {
		if (sessionStorage.getItem("raas-language") !== lenguage) {
			lenguage = sessionStorage.getItem("raas-language") as any;
			setLiteralsDateLanguage(getLiteralsDateLanguage(t))
		}
	}, [t]);

	const detailTmb = (e: any) => {

		let activityInfo = {
			termsAndConditions: "",
			privacyPolicy: "",
			title: "",
			price: {},
			contextType: "",
			provider: "",
			description: {},
			url: "",
			catalogueItemId: ""
		};
		if (detailDataTmb) {
			activityInfo = {
				termsAndConditions: cardTMB?.termsAndConditions,
				privacyPolicy: cardTMB?.privacyPolicy,
				title: detailDataTmb[activitySelectedIndex]?.name,
				price: detailDataTmb[activitySelectedIndex]?.price,
				contextType: detailDataTmb[activitySelectedIndex]?.contextType,
				provider: detailDataTmb[activitySelectedIndex]?.provider,
				description: detailDataTmb[activitySelectedIndex]?.description,
				url: detailDataTmb[activitySelectedIndex]?.image,
				catalogueItemId: detailDataTmb[activitySelectedIndex]?.catalogueItemId

			};
		}
		setTmbActivitySelected(activityInfo);
		//removeTMBSummaryDetail();

		nextStep();
		// navigate("/tmb-night-bus-flow");
	}



	useEffect(() => {
		if (currentStep === 0) {
			//getTmbActivities(i18n.language)
			dataForm.language.id = null;
			removeTMBSummaryDetail();
		}
	}, [currentStep === 0])
	const refreshList = (e: any) => {
		getDetailTmbNigth(
			logged,
			idDetail,
			(response: IDetailTmb[]) => {
				setDetailDataTmb(response);
		
				if(response){
			
					setLanguageData(mappedSessions(response[0].availability,t))
				}else{
					setLanguageData(null)
				}
			},
			(err: any) => { },
			getLanguageTMB(i18n.language),
			dataForm.date.zulu,
			"nigth"
		);
		//}, window.sessionStorage["raas-trip-mock"])
	};

	const getTmbActivities = (lenguage: any) => {
		getDetailTmbNigth(
			logged,
			idDetail,
			(response: IDetailTmb[]) => {
		
				//let prueba=mappedSessions(response[0].availability,t)

				setDetailDataTmb(response);
				//sumarle un dia a la fecha
				if(response[0]?.availability){
					setLanguageData(mappedSessions(response[0].availability,t))

				}else{
					setLanguageData(null)
				}
				setCallSucess(true);
				nextStep();
			},
			(err: any) => {
				setCallSucess(true);
				nextStep();
		
			},
			getLanguageTMB(i18n.language),
			dataForm.date.zulu,
			"nigth"
			);
		};
		const saveData = (e: any) => {

		let typeForm = e.idForm;
		switch (typeForm) {
			case "languageBus":
				dataForm.language.value = e.idTitle;
				dataForm.language.time = e.time;
				dataForm.language.id = e.id;
				dataForm.language.noMapped = e.noMapped;
				dataForm.language.serviceDate=e.serviceDate
				dataForm.language.provider='tmb'
				dataForm.language.contextType='BOOKEE_CONTEXT'

				if(dataForm.passengers.passengers.length!=0){
					dataForm.passengers.passengers =
					getTmbActivitySelected().price.map(
					   (item: any, index: number) => {
						   return {
							   ...item,
							   default: 0,
						   };
					   },
				   );
				}
			
				//dataForm.date.zulu= formatDate(e.value,time)
				nextStep();
				break;
			case "dateBus":
				const date = new Date(e.value);
				const dateAux = new Date();
				const month = date.toLocaleString("default", {
					month: "short",
				});


				const time =
					("0" + dateAux.getHours()).slice(-2) +
					":" +
					("0" + dateAux.getMinutes()).slice(-2);

				const valueFormat = date.getDate() + " " + month;
				
				dataForm.date.value = e.value;
				dataForm.date.time = time;
				dataForm.date.valueFormat = valueFormat;
				dataForm.date.zulu= formatDate(e.value,time)
				getTmbActivities(i18n.language)
				//nextStep();
			
				break;
			case "description":

				nextStep();
				break
			case "passengers":
				dataForm.passengers.passengers = e.value.passengers;
				dataForm.passengers.totalCount = e.value.totalCount;
				dataForm.passengers.totalPrice = e.value.totalPrice;

				dataForm.title = detailDataTmb ? detailDataTmb[activitySelectedIndex]?.name : ""
				if (logged) {
					const missingMandatoryInfo =
						userConnected?.missingMandatoryInfo;
					// force mandatory info
					if (missingMandatoryInfo) {
						setOpenMissing(true);
						return;
					} else {				
						setCurrentStep(0)
						setOffSite(false)
    					setDataCodePromoSession({ voucherCode: '',voucherAmount:0, discountType: 'DOCO', isValid: false, reset:false,totalPrice:'0,00 €',totalPriceToPay:'0,00 €' })
						navigate("/tmb-resume-route");
					}
				} else {
					setShowLoginModal(true);
				}

				break;
			default:
				break;
		}

		setProductTMBDetails(dataForm);
		setTMBSummaryDetail(dataForm);
	};
	const getComponentNightBus = (currentStep: number): JSX.Element => {
		let currentComponent: JSX.Element = <div></div>;
		switch (currentStep) {
			case 0:
				currentComponent = (
					<PTmbDateBus
						literals={literalsDateLanguage}
						onSendDataEmit={(ev) => saveData(ev?.detail)}
						initialSelectedDate={
							initTMBSummaryDetail()?.date?.value
						}
						onGoBackEmit={() => {
							navigate("/plan");
						}}
					></PTmbDateBus>
				);
				break;
			case 1:
				currentComponent = (
					<PTmbLanguageBus
						literals={literalsPageLanguage}
						literalsDetail={literalsDetail}
						literalsModal={literalsModal}
						onSendDataEmit={(ev) => saveData(ev?.detail)}
						onGoBackEmit={() => {
							backStep();
						}}
						initialSelectedCard={initTMBSummaryDetail()?.language?.id}
						onTryAgain={()=>setCurrentStep(currentStep - 1)}
						cards={languageData}
					></PTmbLanguageBus>
				);
				break;
			case 2:
				currentComponent = (
					<>
						<PTmbDetailActivity
							onBuyTmb={detailTmb}
							onTryAgain={refreshList}
							// onActivitySelected={activitySelected}
							literalsDetail={literalsDetail}
							//Simular error con el null
							//activitiesList={null}
							activitiesList={detailDataTmb}
							/>
					</>
				)
				break;
			case 3:
				currentComponent = (
					<>
						<PTmbPassengers
							passengers={passengersInfo()}
							literals={literalsPassengers}
							literalsModal={getTmbPassengerSeniorModal(t3)}
							onSendDataEmit={(ev) => saveData(ev?.detail)}
							onGoBackEmit={() => {
								backStep();
							}}
						></PTmbPassengers>
						{showLoginModal ? (
							<LoginModal
								openMissing={openMissing}
								openModal={showLoginModal}
								urlNavigate="/tmb-night-bus-flow"
							/>
						) : null}
					</>
				);
				break;
		}
		return currentComponent;
	};

	const goBackStepper = (step: number) => {
		setCurrentStep(step);
	};

	const nextStep = () => {
		//currentStep === 2;
		setCurrentStep(currentStep + 1);
	};
	const backStep = () => {
		//currentStep === 2;
		setCurrentStep(currentStep - 1);
	};

	return (
		<>
			<div className="tmb-flow">
				<div className="tmb-stepper-container">
					<div className="tmb-flow_stepper">
						<UiAveStepper
							steps={nightBusStep(t)}
							activeStep={currentStep}
							onEventStepChanged={(ev) =>
								goBackStepper(ev?.detail)
							}
						></UiAveStepper>
					</div>
				</div>
				<div className="tmb-flow_body">
					<div className="section-body">
						<div className="left-section">
							{getComponentNightBus(currentStep)}
						</div>
						<div className="rigth-section"></div>
					</div>
					<div className="section">
						<div className="mt-80">
							<LegalFooter
								literals={footerLiterals}
							></LegalFooter>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};


